export interface ICaseStudyResult {
    id: string
    company: string
    logoUrl: string
    region: string
    regionFlag: string
    stats: { value: string; label: string }[]
    quote: string
    quotee: { name: string; title: string; avatarUrl?: string }
    images: string[]
    hasCaseStudyLink?: boolean
    agency?: boolean
}

const R = '/assets/landing-page/results'

export const RESULTS_DATA: ICaseStudyResult[] = [
    {
        id: 'taxfix',
        company: 'TaxFix',
        logoUrl: `${R}/taxfix/taxfix.png`,
        region: 'Europe',
        regionFlag: '\u{1F1EA}\u{1F1FA}',
        stats: [
            { value: '+37%', label: 'Thumbstop Ratio' },
            { value: '+45%', label: 'Click-Through Rate' },
        ],
        quote: '\u201CWhat convinced me wasn\u2019t the AI part \u2014 everyone\u2019s got an AI story right now. What convinced me was the output quality relative to the speed. We were able to generate creatives that performed on par with or better than other assets, at a fraction of the turnaround time.\u201D',
        quotee: {
            name: 'Alexander Beresford',
            title: 'Chief Growth Officer at Taxfix',
            avatarUrl: `${R}/taxfix/alexander-beresford.png`,
        },
        images: [
            `${R}/taxfix/Taxfix-SampleVideo1.mp4`,
            `${R}/taxfix/Taxfix-SampleVideo2.mp4`,
            `${R}/taxfix/Taxfix-SampleVideo3.mp4`,
        ],
    },
    {
        id: 'sumup',
        company: 'SumUp',
        logoUrl: `${R}/sum-up/SumUp.png`,
        region: 'Europe',
        regionFlag: '\u{1F1EA}\u{1F1FA}',
        stats: [
            { value: '120+', label: 'Meta Ads created' },
            { value: '8+', label: 'Languages localized' },
        ],
        quote: '\u201CWhat started as a pilot quickly scaled across teams. Suddenly, everyone wanted a piece of the cake. Without Superscale, we couldn\u2019t have launched Meta campaigns at this speed or scale.\u201D',
        quotee: {
            name: 'William Simpson',
            title: 'Senior Content Manager at SumUp',
            avatarUrl: `${R}/sum-up/William-Simpson_SumUp.jpeg`,
        },
        images: [
            `${R}/sum-up/SumUp-SampleVideo1.mp4`,
            `${R}/sum-up/SumUp-SampleVideo2.mp4`,
            `${R}/sum-up/sumup-sample-3.mp4`,
        ],
    },
    {
        id: 'advercy',
        company: 'Advercy',
        logoUrl: `${R}/advercy/Advercy.png`,
        region: 'Germany',
        regionFlag: '\u{1F1E9}\u{1F1EA}',
        stats: [
            { value: '50%', label: 'Lower CPL' },
            { value: '95%', label: 'Lower UGC production cost' },
        ],
        quote: '\u201CSuperscale removed my dependency on designers and influencer UGC teams. As a result, I can iterate and test creative approaches much faster; ideas that used to take hours are now turned into fully functional assets in minutes.\u201D',
        quotee: {
            name: 'Dario Stock',
            title: 'Founder of Advercy',
            avatarUrl: `${R}/advercy/dario-stock_quote-advercy.jpeg`,
        },
        images: [
            `${R}/advercy/006siv4wAawcr7HtjHA3smuP8a4.mp4`,
            `${R}/advercy/5ni9GT3z8kAxk7UT038a6roIDtg.mp4`,
            `${R}/advercy/hoZdPflM7OgSRFfsszSFX2VcGSM.mp4`,
        ],
        agency: true,
    },
    {
        id: 'stromnow',
        company: 'StromNow',
        logoUrl: `${R}/stromNow/stromnow.jpeg`,
        region: 'Germany',
        regionFlag: '\u{1F1E9}\u{1F1EA}',
        stats: [
            { value: '20x', label: 'Lower Cost Per Video' },
            { value: '2x', label: 'More App Downloads' },
        ],
        quote: '\u201CWith Superscale, we can test more ideas in a week than we used to in a month. That speed is what makes organic TikTok growth predictable for us.\u201D',
        quotee: {
            name: 'Kim Eberhardt',
            title: 'Co-Founder & Co-CEO at StromNow',
            avatarUrl: `${R}/stromNow/kim-eberhardt.jpeg`,
        },
        images: [
            `${R}/stromNow/StromNow-SampleVideo1.mp4`,
            `${R}/stromNow/StromNow-SampleVideo2.mp4`,
            `${R}/stromNow/StromNow-SampleVideo3.mp4`,
        ],
    },
    {
        id: 'lila',
        company: 'Lila',
        logoUrl: `${R}/lila/Lila.png`,
        region: 'USA',
        regionFlag: '\u{1F1FA}\u{1F1F8}',
        stats: [
            { value: '+6x', label: 'Cost Per Trial reduction' },
            { value: '2x', label: 'CPI reduction' },
        ],
        quote: '\u201CSeveral agencies told us we would not be able to lower our CPI significantly, Superscale\u2019s AI UGC creative actually enabled us to go down 2x.\u201D',
        quotee: {
            name: 'Sebastian Jorna',
            title: 'Co-founder, CEO at Lila',
            avatarUrl: `${R}/lila/sebastian-jorna.jpeg`,
        },
        images: [`${R}/lila/Sample-Video.mp4`, `${R}/lila/Sample-Video2.mp4`, `${R}/lila/Sample-Video3.mp4`],
    },
    {
        id: 'aligned',
        company: 'Aligned',
        logoUrl: `${R}/aligned/aligned.png`,
        region: 'United States',
        regionFlag: '\u{1F1FA}\u{1F1F8}',
        stats: [
            { value: '+160%', label: 'Click-Through Rate' },
            { value: '+105%', label: 'Higher Hook Rate' },
        ],
        quote: '\u201CEveryone\u2019s talking about AI - but that\u2019s not what won me over. What convinced me was the speed and quality of the results, which allow us to create the most effective advertising materials faster than ever before, without compromising on effectiveness. Our team can easily collaborate on creating avatars, scenes, and new concepts - all of this is available in Superscale.\u201D',
        quotee: {
            name: 'Artem Kharytonenko',
            title: 'Creative Marketing Manager at Aligned',
            avatarUrl: `${R}/aligned/artem-kharytonenko.png`,
        },
        images: [
            `${R}/aligned/Superscale_Speaking_Character_1.mp4`,
            `${R}/aligned/Superscale_Speaking_Character_2.mp4`,
            `${R}/aligned/Superscale_Character_with_Sign_Static_4-5.jpeg`,
        ],
        hasCaseStudyLink: false,
    },
    {
        id: 'ordio',
        company: 'Ordio',
        logoUrl: `${R}/ordio/ordio.jpeg`,
        region: 'Germany',
        regionFlag: '\u{1F1E9}\u{1F1EA}',
        stats: [
            { value: '-20%', label: 'CPL for Meta Acquisition Campaigns' },
            { value: '-70%', label: 'CPL for Meta Whitepaper Campaigns' },
        ],
        quote: '\u201CSuperscale has helped us in performance marketing to test new hooks and angles much faster and identify winning creatives more efficiently. The quality of the videos is unmatched compared to other platforms. Especially in times of Meta Andromeda, Superscale supports us in increasing creative diversity and overall creative output. With the speed the tool offers, we can now validate more creatives in one week than we used to in several months.\u201D',
        quotee: {
            name: 'Janis Sch\u00F6rner',
            title: 'Performance Marketing Manager at Ordio',
            avatarUrl: `${R}/ordio/janis-schoerner.jpeg`,
        },
        images: [
            `${R}/ordio/Ordio-SampleVideo1.mp4`,
            `${R}/ordio/Ordio-SampleVideo2.mp4`,
            `${R}/ordio/Ordio-SampleVideo3.mp4`,
        ],
        hasCaseStudyLink: false,
    },
    {
        id: 'marketbirds',
        company: 'marketbirds',
        logoUrl: `${R}/marketbirds/marketbirds.png`,
        region: 'Germany',
        regionFlag: '\u{1F1E9}\u{1F1EA}',
        stats: [
            { value: '540%', label: 'Increase in Creative Output' },
            { value: '+26%', label: 'Click-Through-Rate Uplift' },
        ],
        quote: '\u201CFor us, this is 100% an efficiency play. Within a single week, we generated enough ads to test for an entire month, at a fraction of the time. Instead of paying for freelancers and internal production, we now get better results, faster, and deliver significantly more value to our clients.\u201D',
        quotee: {
            name: 'Thomas Pietrek',
            title: 'Managing Director at marketbirds GmbH',
            avatarUrl: `${R}/marketbirds/thomas-pietrek.jpeg`,
        },
        images: [
            `${R}/marketbirds/Marketbirds-SampleImage1.png`,
            `${R}/marketbirds/Marketbirds-SampleImage2.jpeg`,
            `${R}/marketbirds/Marketbirds-SampleImage3.jpeg`,
        ],
        hasCaseStudyLink: true,
        agency: true,
    },
]
